/**
 * <product-before-after>
 * Overlay-tabs Before/After showcase sourced from the product's
 * `custom.before_after` metaobject list. When a product has more than one
 * entry, the overlaid segmented tabs switch between the pairs. Single-entry
 * products render just the pair (no tabs).
 */
class ProductBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('.pba__media'));
    this.tabs = Array.from(this.querySelectorAll('.pba__tab'));

    this.tabs.forEach((el) => {
      el.addEventListener('click', () => this.select(Number(el.dataset.index)));
    });
  }

  select(index) {
    this.panels.forEach((el) => el.toggleAttribute('data-active', Number(el.dataset.index) === index));
    this.tabs.forEach((el) => el.setAttribute('aria-selected', Number(el.dataset.index) === index ? 'true' : 'false'));
  }
}

if (!customElements.get('product-before-after')) {
  customElements.define('product-before-after', ProductBeforeAfter);
}
